module.exports = __webpack_public_path__ + "img/trazado4.589f35dd.webp";